import FileManagerContainer from "../../Componant/FileManager";

const FileManager = () => {
  return (
    <div className="page-body">
      <FileManagerContainer />
    </div>
  );
};

export default FileManager;
